<div class="modal-header">
  <div class="d-flex justify-content-center">
    <h4><strong>{{titel}}</strong></h4>
  </div>
</div>
<div class="modal-body">
  <div class="d-flex my-3">
    <p>{{message}}</p>
  </div>
</div>
<div class="modal-footer">
  <button
  class="btn btn-danger"
  (click)="activeModal.close(false)">
  Cancelar
</button>
<button
  class="btn btn-primary"
  (click)="activeModal.close(true)">
  Aceptar
</button>
</div>
